/**
 * Returns formatted phone number with space after each three digits.
 * @param number a phone number as a string
 */
export const formatPhoneNumber = (number: string): string =>
  number.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
